const shortMonthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
] as const;

const longMonthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
] as const;

function getUtcDateParts(value: string) {
  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    throw new RangeError(`Invalid content date: ${value}`);
  }

  return {
    day: date.getUTCDate(),
    month: date.getUTCMonth(),
    year: date.getUTCFullYear(),
  };
}

export function formatShortContentDate(value: string) {
  const { day, month, year } = getUtcDateParts(value);
  return `${day} ${shortMonthNames[month]} ${year}`;
}

export function formatLongContentDate(value: string) {
  const { day, month, year } = getUtcDateParts(value);
  return `${day} ${longMonthNames[month]} ${year}`;
}

export function formatShortContentMonth(value: string) {
  const { month, year } = getUtcDateParts(value);
  return `${shortMonthNames[month]} ${year}`;
}
